/* eslint-disable dot-notation */
import React from 'react';
import { useSelector } from 'react-redux';
import { selectProductSearchResultInitialFacets } from 'core/modules/ProductSearchResults/selectors';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import FilterDesktop from './components/FilterDesktop';
import FilterPromotionsDesktop from './components/FilterPromotionsDesktop';
import SortDesktop from './components/SortDesktop';
import ActiveFiltersDesktop from './components/ActiveFiltersDesktop';

import { productSearchResultsConfig as config } from '../../configs';

import './MenuDesktop.scss';

function MenuDesktop({ filterHook, productResultsHook, sortedActiveFilters }) {
  const initialFacets = useSelector(selectProductSearchResultInitialFacets);
  const { categoriesFilterTitle } = config;

  return (
    <div className="mn_psrMenuDesktop">
      <div className="mn_filtersAndSort">
        <div className="mn_filters">
          <div className="mn_filterBy">Filter by:</div>
          <div className="mn_filtersDropdown">
            <FilterDesktop facet={initialFacets['merchants']} filterHook={filterHook} title="Stores" />
            <FilterDesktop facet={initialFacets['categories']} filterHook={filterHook} title={categoriesFilterTitle} />
            <FilterDesktop facet={initialFacets['brands']} filterHook={filterHook} />
            <FilterDesktop facet={initialFacets['price']} filterHook={filterHook} />
            <FilterPromotionsDesktop filterHook={filterHook} />
          </div>
        </div>
        <SortDesktop productResultsHook={productResultsHook} />
      </div>
      <ActiveFiltersDesktop filterHook={filterHook} sortedActiveFilters={sortedActiveFilters} />
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><MenuDesktop {...props} /></ComponentErrorBoundary>;
